var _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoInternet = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 136,
  height: 95,
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fee6c3",
  d: "M3.735 63.168c4.508 6.465 12.408 10.309 20.82 10.13h86.85c12.93.217 23.724-8.931 24.403-20.684s-8.998-21.883-21.883-22.901C112.812 15.915 102.099 4.325 87.353.963S57.154 3.227 49.025 14.916c-5.738-1.985-12.16-1.459-17.416 1.427s-8.761 7.812-9.506 13.357c-8.387.603-15.815 5.161-19.574 12.011S-.773 56.703 3.735 63.168"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f3594e",
  d: "m65.332 72.996-8.937 10.843h8.937l-5.958 10.844L80.226 81.13H68.31l8.937-8.135z"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeLinejoin: "miter",
  strokeWidth: 2.5,
  d: "m57.047 52.415 11.658-.092 11.237.091"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  stroke: "none",
  d: "M53.488 34.86c0-1.666 1.475-3.009 3.307-3.009s3.306 1.343 3.306 3.01-1.475 3.008-3.306 3.008-3.307-1.342-3.307-3.008m23.147 0c0-1.666 1.475-3.009 3.307-3.009s3.306 1.343 3.306 3.01-1.475 3.008-3.306 3.008-3.307-1.342-3.307-3.008"
})));
export { SvgNoInternet as ReactComponent };
export default __webpack_public_path__ + "images/no-internet.e00f9797.svg";